import { Flex } from "antd";
import { CompanyActivity } from "../../../../app/model/company";
import { Tag, TagsContainer, TagsTitle } from "./styles";
import {locale} from "../../lang"
import i18n from "../../../../i18n";
import {localeColumns} from "../../../../components/grid/const";

interface ViewTagsProps {
  activities: CompanyActivity[];
}

export default function ViewTags({ activities }: ViewTagsProps) {
  const tagsColors: { [key: number]: { color: string, darkText: boolean } } = {
    1: { color: "#ef713a", darkText: false }, // Aquaculture
    2: { color: "#034390", darkText: false }, // Catching and Processing 
    5: { color: "#f7c362", darkText: true }, // Product Distribution
    6: { color: "#aedbf9", darkText: true }, // Shipbuilding and Ship repair 
    7: { color: "#2490a4", darkText: false }, // Equipment and Components 
    9: { color: "#d7d8d5", darkText: true }, // Other
    10: { color: "#8dc3bc", darkText: true }, // Deep Processed Products 
    11: { color: "#f79953", darkText: false }, // Logistics & Storage 
  }

  if (!activities.length) {
    return <></>
  }
  const lang = i18n.language as "ru" | "en"
  return (
    <Flex gap={8} vertical style={{ marginBottom: 16 }} >
      <TagsTitle children={locale.categories[lang]} />
      <TagsContainer>
        {activities.map(activity => (
          <Tag
            {...tagsColors[activity.categoryId]}
            key={activity.id}
            children={lang=='ru'?activity.name:activity.nameEn}
          />
        ))}
      </TagsContainer>
    </Flex>
  )
}
